import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("mazboy_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(false);

  const login = useCallback(async (email, password) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("mazboy_token", data.access_token);
      localStorage.setItem("mazboy_user", JSON.stringify(data.user));
      setUser(data.user);
      return data.user;
    } finally {
      setLoading(false);
    }
  }, []);

  const replaceLogin = useCallback(async (email, password, challenge) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login/replace", {
        email, password, challenge
      });
      localStorage.setItem("mazboy_token", data.access_token);
      localStorage.setItem("mazboy_user", JSON.stringify(data.user));
      setUser(data.user);
      return data.user;
    } finally {
      setLoading(false);
    }
  }, []);
  const logout = useCallback(() => {
    localStorage.removeItem("mazboy_token");
    localStorage.removeItem("mazboy_user");
    setUser(null);
  }, []);

  useEffect(() => {
    if (!user) return;
    api.get("/auth/me").then(({ data }) => {
      setUser(data);
      localStorage.setItem("mazboy_user", JSON.stringify(data));
    }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AuthCtx.Provider value={{ user, loading, login, replaceLogin, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
